export default "https://cdn-web.disco.co/series-48a4bcc7d58c9b197036e0beafcb1816.png";